import React from "react"
import styles from './corps.module.scss'
import cheerio from "cheerio"
import PlaceElement from "./placeElement"


const Corps = (props) => {
  let bodyArray = splitCorps(props.content);
  let JSXarray = []
  bodyArray.forEach((i, idx) => {
    if ( i.indexOf("<secondaryobject") === -1){
      JSXarray.push(<div key={idx} className={styles.bodytext} dangerouslySetInnerHTML={{ __html: i }} />)
    } else {
      let $ = cheerio.load(i)
      let secondaryId = $('secondaryobject').attr('referenceno')
      let objectToTransfer = findObjectWithId(secondaryId, props.secondaryObjects)
      JSXarray.push(<PlaceElement key={idx} object={objectToTransfer} sizes="(max-width: 600px) 100vw, 720px" />)
    }
  })


  return(
    <div>
      {JSXarray.map((item) => (
        item
      ))}
    </div>
  )
}

export default Corps



function findObjectWithId(id, secondaryObjects){
  for(let i=0; i< secondaryObjects.length; i++ ){
    // console.log('secondaryObjects[i]: ', secondaryObjects[i]);
    if (secondaryObjects[i].referenceNo === id ){
      // console.log('is correct id')
      return secondaryObjects[i]
    } else {
      // console.log('not correct id')
    }
  }
}

function splitCorps(HTMLString){
  // Returns an array of strings, each item has either normal texte(html) or a secondary object.
  let finalArray = []

  let p
  let part
  while (HTMLString.length > 0){
    // look for secondary object
    p = HTMLString.indexOf("<secondaryobject")
    if (p === -1){
      finalArray.push(HTMLString)
      break
    }
    // get string before secondary object and place in array
    part = HTMLString.slice(0,p)
    finalArray.push(part)
    // remove the part from the original string
    HTMLString = HTMLString.slice(p)
    // find the secondary object string and place it in array, then remove it from original string.
    p = HTMLString.indexOf("</secondaryobject>")
    part = HTMLString.slice(0,p+18)
    finalArray.push(part)
    HTMLString = HTMLString.slice(p+18)

  }
  // console.log('finalArray: ', finalArray)
  return finalArray
}